import React from "react";
import { Box, Chip } from "@mui/material";

export const promoStoreNavigationChipSx = (active) => ({
  cursor: "pointer",
  fontWeight: 600,
  fontSize: "0.72rem",
  height: 26,
  backgroundColor: active ? "var(--ec-color-primary)" : "var(--ec-status-neutral-bg)",
  color: active ? "var(--ec-color-surface)" : "var(--ec-status-neutral-text)",
  border: active ? "1px solid transparent" : "1px solid var(--ec-status-neutral-border)",
  transition: "all 0.15s ease",
  "& .MuiChip-label": { px: "10px" },
  "&:hover": {
    backgroundColor: active ? "var(--ec-color-primary-dark)" : "var(--ec-color-surface-muted)",
  },
});

export const buildPromoStoreScopeTabs = ({ canViewAllStores, canViewArchivedStores }) => [
  { key: "my", label: "My Stores", visible: true },
  { key: "all", label: "All Stores", visible: canViewAllStores },
  { key: "marketplace", label: "Marketplace", visible: true },
  { key: "archived", label: "Archived", visible: canViewArchivedStores },
].filter((tab) => tab.visible);

const PromoStoreNavigation = ({ items, activeKey, onSelect }) => (
  <Box
    component="nav"
    aria-label="PromoStore views"
    sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}
  >
    {items.map(({ key, label }) => {
      const active = activeKey === key;
      return (
        <Chip
          key={key}
          label={label}
          size="small"
          clickable
          aria-current={active ? "page" : undefined}
          onClick={() => onSelect(key)}
          sx={promoStoreNavigationChipSx(active)}
        />
      );
    })}
  </Box>
);

export default PromoStoreNavigation;
